'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacers.BASE}rem;
`;

export const CheckboxWrapper = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const Text = styled.label`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
`;

export const CustomCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${Spacers.LG}rem;
  height: ${Spacers.LG}rem;
  background-image: url('/assets/icons/Unchecked.svg');
`;


export const HiddenCheckbox = styled.input`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;

  &:focus-visible + ${CustomCheckbox} {
    outline: 2px solid rgb(0, 100, 214);
    outline-offset: 2px;
    border-radius: 4px;
  }

  &:checked + ${CustomCheckbox} {
    background-image: url('/assets/icons/Checked.svg');
  }

  @media (hover: hover) and (pointer: fine) {
    &:not(:checked):hover + ${CustomCheckbox} {
      background-image: url('/assets/icons/CheckboxHover.svg');
    }
  }
  
`;

